const getURL = (path = '', extra = '/RPServices') => {
  return `${process.env.REACT_APP_BASE_URL}${extra}${path}`;
};

export { getURL };



// WEBPACK FOOTER //
// ./src/utils/apiURLBuilder.js